import React from "react";
function Tax () {
    return (

        <h2>Tax</h2>
    )
    
}
export default Tax;